import { render, staticRenderFns } from "./ReviewsDashboard.vue?vue&type=template&id=5acdff77&scoped=true"
import script from "./ReviewsDashboard.vue?vue&type=script&lang=js"
export * from "./ReviewsDashboard.vue?vue&type=script&lang=js"
import style0 from "./ReviewsDashboard.vue?vue&type=style&index=0&id=5acdff77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acdff77",
  null
  
)

export default component.exports